$(function () {
	var underlineSelectors = '.o-wysiwyg h2 > span[style*="underline"], .o-wysiwyg h2 > u, .o-wysiwyg h3 > span[style*="underline"], .o-wysiwyg h3 > u, .m-headline h1 > u';

	if ($(underlineSelectors).length) {
		var $headlines = '';

		$(underlineSelectors).each(function() {
			var $el = $(this);

			var length = parseInt($el.width());

			var lengthClass = 'sx';

			var symbol = '<svg viewBox="0 0 287 24"><use xlink:href="#underline"></use></svg>';

			if (length >= 280) {
				lengthClass = 'lg';
			} else if (length < 280 && length >= 180) {
				lengthClass = 'md';
			} else if (length < 180 && length >= 100) {
				lengthClass = 'sm';
			}

			if (lengthClass == 'lg' || lengthClass == 'md') {
				symbol = '<svg viewBox="0 0 410 22"><use xlink:href="#underline-medium"></use></svg>';
			}

			$el
				.addClass('a-hand-underline ' + lengthClass)
				.append(symbol);

			$headlines = $headlines === '' ? $el.parent() : $headlines.add($el.parent());
		});

		if ($headlines.length) {
			var headingObserver = new IntersectionObserver(function(entries, observer) {
				$.each(entries, function(entryIndex, entry) {

					if(entry.isIntersecting){
						$(entry.target).children('span[style*="underline"], u').addClass('io-in-view');

						observer.unobserve(entry.target);
					}

				});
			}, {
				rootMargin: '-20% 0%',
				threshold: 0.5
			});

			$headlines.each(function() {
				headingObserver.observe(this);
			});
		}
	}
});
